import React, { FC, memo } from 'react'
import CloseIcon from '@ucheba/ui/icons/icon__close.svg'
import { IChipsProps } from '../types'
import SC from '../base/Chips.styles'
import { Button } from '../../Button/desktop'
import { useChipsCore } from '../bll'
import { Text } from '../../Text/desktop'

const { Block } = SC

/** Чипс */
const Chips: FC<IChipsProps> = (props) => {
  const {
    clear,
    color,
    onClick,
    children,
    firstLetterUppercase,
    variant,
    ...otherProps
  } = props
  const { onClear, rendering } = useChipsCore({ onClick })

  if (!rendering) return null

  return (
    <Block color={color} clear={clear} variant={variant} {...otherProps}>
      <Text firstLetterUppercase={firstLetterUppercase} html={false}>
        {children}
      </Text>

      {clear && (
        <Button size='xsmall' icon shape='circle' onClick={onClear}>
          <CloseIcon width='16px' height='16px' />
        </Button>
      )}
    </Block>
  )
}

export { Chips }
export default memo(Chips)
